import * as React from "react"
import { cn } from "../../lib/utils"

const DecidrBody = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement> & {
    as?: 'p' | 'span' | 'div'
    size?: 'xs' | 'sm' | 'base' | 'lg' | 'xl'
  }
>(({ className, as: Component = 'p', size = 'base', ...props }, ref) => {
  const getTextSize = (size: string) => {
    switch (size) {
      case 'xs':
        return 'text-xs leading-relaxed'
      case 'sm':
        return 'text-sm leading-relaxed'
      case 'base':
        return 'text-base leading-relaxed'
      case 'lg':
        return 'text-lg leading-relaxed'
      case 'xl':
        return 'text-xl leading-relaxed'
      default:
        return 'text-base leading-relaxed'
    }
  }

  return (
    <Component
      ref={ref}
      className={cn(
        "font-sans text-on-surface-default",
        getTextSize(size),
        className
      )}
      {...props}
    />
  )
})
DecidrBody.displayName = "DecidrBody"

export { DecidrBody } 